import React, { FC, ReactNode } from 'react'
import { useTheme } from '@config/theme.config'

interface PageHeaderProps {
  children: ReactNode
}

const PageHeaderComponent: FC<PageHeaderProps> = ({ children }) => {
  const { theme } = useTheme()
  return (
    <div className={`bg-light-subtle text-bg-${theme} shadow-sm`}>
      <div className="app-max-width px-0">{children}</div>
    </div>
  )
}
export default PageHeaderComponent
